// extracted by mini-css-extract-plugin
export default {"Table":"Tabel_Table__nv6a2"};